// Set up your root reducer here...
import { combineReducers } from "redux";
import auth from "@auth/reducers/authenticationReducer";
import mqtt from "@common/reducers/mqttReducer";
import userInfo from "@profile/reducers/userReducer";
import wifi from "@common/reducers/WifiReducer";
import beers from "@beers/reducers/beerReducer";
import brewery from "@brewery/reducers/breweryReducer";
import announcements from "../../announcements/reducers/announcementsReducer";
import device from "@common/reducers/deviceReducer";
import ingredients from "@beers/reducers/ingredientReducer";
import { connectRouter } from "connected-react-router";
import { loadingBarReducer } from "react-redux-loading-bar";
import { reducer as reduxFormReducer } from "redux-form";
import { reducer as notificationsReducer } from "reapop";

// connected-react-router's router reducer needs the history instance, so the
// root reducer is now a factory. It must be mounted under `router` (the library
// asserts this key exists); mapStateToProps consumers alias it back to `routing`.
const createRootReducer = (history) =>
  combineReducers({
    auth,
    mqtt,
    userInfo,
    wifi,
    beers,
    announcements,
    brewery,
    device,
    ingredients,
    loadingBar: loadingBarReducer,
    router: connectRouter(history),
    form: reduxFormReducer,
    notifications: notificationsReducer()
  });

export default createRootReducer;
